module.exports = __webpack_public_path__ + "img/145.2675f032.jpg";